import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {Collapse, Input} from "antd";
import {useStore} from "../../store";
import SearchGlobalRecord from "./search-global-record";
import SearchGlobalLibrary from "./search-global-librar";
import SearchGlobalPicture from "./search-global-picture";
import SearchGlobalDna from "./search-global-dna";
import SearchGlobalPublicity from "./search-global-publicity";

const SearchGlobal:React.FC = () => {

    const {searchGlobal} = useStore();

    useEffect(() => {
        searchGlobal.queryGlobal("");
        return searchGlobal.clear
    },[])

    const onKeyChange = (e:any) => {
        searchGlobal.setSearchWord(e.target.value);
    }
    const onRecordCollapse = (key:string|string[], position: number) => {
        // if (searchGlobal.recordCollapse.length > 0) {
        //     searchGlobal.recordCollapse = [];
        // } else {
        //     searchGlobal.recordCollapse = ["record"]
        // }
        if (key.length<= 0) {
            searchGlobal.recordCollapse[position] = ""
        } else {
            searchGlobal.recordCollapse[position] = key[0]
        }
    }

    return (<Wrapper>
        <TitleSpan>检索结果</TitleSpan>
        <SearchWrapper>
            <Input onChange={onKeyChange} value={searchGlobal.searchWord} className={"searchInput"} />
            <button onClick={() => searchGlobal.queryGlobal("")} className={"searchButton"}>搜索</button>
        </SearchWrapper>
        <Collapse onChange={(key) => onRecordCollapse(key, 0)} activeKey={"record"} expandIconPosition={"end"}>
            <Collapse.Panel key={searchGlobal.recordCollapse[0]} header={"标本记录"} >
                <SearchGlobalRecord/>
            </Collapse.Panel>
        </Collapse>
        <Collapse onChange={(key) => onRecordCollapse(key, 1)}  expandIconPosition={"end"} activeKey={"library"}>
            <Collapse.Panel key={searchGlobal.recordCollapse[1]} header={"原植物图库"} >
                <SearchGlobalLibrary/>
            </Collapse.Panel>
        </Collapse>
        <Collapse onChange={(key) => onRecordCollapse(key, 2)}  expandIconPosition={"end"} activeKey={"picture"} defaultActiveKey={searchGlobal.recordCollapse[2]}>
            <Collapse.Panel key={searchGlobal.recordCollapse[2]} header={"图谱库"} >
                <SearchGlobalPicture/>
            </Collapse.Panel>
        </Collapse>
        <Collapse onChange={(key) => onRecordCollapse(key, 3)}  expandIconPosition={"end"} activeKey={"dna"} defaultActiveKey={searchGlobal.recordCollapse[3]}>
            <Collapse.Panel key={searchGlobal.recordCollapse[3]} header={"DNA序列库"} >
                <SearchGlobalDna/>
            </Collapse.Panel>
        </Collapse>
        <Collapse onChange={(key) => onRecordCollapse(key, 4)}   expandIconPosition={"end"} activeKey={"publicity"} defaultActiveKey={searchGlobal.recordCollapse[4]}>
            <Collapse.Panel key={searchGlobal.recordCollapse[4]} header={"科普宣传"} >
                <SearchGlobalPublicity/>
            </Collapse.Panel>
        </Collapse>
    </Wrapper>);
}
export default observer(SearchGlobal);
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    flex: 1;
    overflow: scroll;
    padding: 20px;
    .ant-collapse{
      margin-top: 20px;
    }
    .ant-collapse-item >.ant-collapse-header{
      background: #D2E2F8;
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 24px;
    }
  
    .ant-collapse .ant-collapse-content>.ant-collapse-content-box{
      padding: 0;
    }
  }
`;
const TitleSpan = styled.span`
  & {
    font-size: 22px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #666666;
    line-height: 33px;
    align-self: center;
    margin-top: 13px;
  }
`;
const SearchWrapper = styled.div`
  & {
    margin-top: 15px;
    align-self: center;
    display: flex;
    height: 33px;
    margin-bottom: 25px;
    .searchInput{
      width: 423px;
      background: #FFFFFF;
      box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.05);
      border-radius: 4px;
      border: 1px solid rgba(16,87,218,0.2);
      height: 32px;
    }
    .searchButton{
      margin-left: 10px;
      width: 65px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #1990FF;
      color: #1990FF;
      cursor: pointer;
    }
  }
`;
const Divider = styled.div`
  height: 20px;
`;